<template>

<div>
  <!-- Utility Section -->

  <div>
      <h4>{{utilLabel}} Supply</h4>
      <el-button v-if="isManager('finance|project|maintenance')" type="text" @click="editState()"><i :class="editing ? 'fa fa-check-circle' : 'fa fa-edit'"></i></el-button>
      <el-button v-if="this.editing" type="text" @click="editing = false"><i class="fa fa-times-circle"></i></el-button>
  </div>

  <el-form :inline="true" label-position="top" ref='utilityForm' :model='details'>

<!--
    <el-form-item label="Own Meter">
      <check-box v-model="details.ownMeter" :disabled="!editing" />
    </el-form-item>

    <el-form-item label="Utility Billing">
      <check-box v-model="details.utilityROW" :disabled="!editing" />
    </el-form-item>

    <el-form-item label="Billing Start" v-if="canAccess('finance')">
      <el-date-picker :format="format" v-model="details.utilityROWBillingStart" :disabled="!editing && !details.utilityROW" />
    </el-form-item>
-->
    <el-form-item label="Deposit"  v-if="canAccess('finance')">
      <el-input type="number" v-model="details.utilityDeposit" :disabled="!editing" />
    </el-form-item>

    <el-form-item label="Std. Rate"  v-if="canAccess('finance')">
      <el-input type="number" v-model="details.utilityStandardRate" :disabled="!editing" />
    </el-form-item>

  </el-form>

  <util-equip :site-id="details.site_id" :site-data="siteData" :owner-id="details.organisation_id"></util-equip>

</div>

</template>

<script>

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

import {settings} from '@/components/Data'

import UtilEquip from '@/components/assets/subcat/UtilEquipTable'

export default {
  mixins: [PostMixins, DateMixins],

  components: {
    UtilEquip
  },

  props: {
    sharer: {
      type: Object,
      required: true
    },

    siteData: {
      type: Object
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },

  methods: {
    editState () {
      if (this.editing) {

        if (this.details.utilityROWBillingStart) {
          this.details.utilityROWBillingStart = this.formatDateSql(this.details.utilityROWBillingStart)
        }

        this.saveForm(this, '/licensees', this.details.id, this.details, 'Sharer Utility Data', this.saveSucccess)
        this.editing = false
      } else {
        this.editing = true
      }
    }
  },

  data () {
    return {
      editing: this.editMode,
      utilLabel: this.getUtilLabel(this.siteData),
      format: settings.selectDateFormat,
      details: this.sharer
    }
  }
}

</script>



// WEBPACK FOOTER //
// UtilityTab.vue?507cc9e1